/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPosts.defs'
export { main as default } from './getPosts.defs'
